"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var SelectDropdown_1 = __importDefault(require("@/react-app/common/components/SelectDropdown"));
var Input_1 = __importDefault(require("@/react-app/common/components/Input"));
var sanitizeInputText = function (text) { return text.replace(/[^0-9.]/g, ''); };
var determineRange = function (filterValue) {
    var isRangeFilter = filterValue && filterValue.includes(' TO ');
    var isMaxOrMinFilter = filterValue && (filterValue.includes('>=') || filterValue.includes('<='));
    if (isRangeFilter) {
        var _a = __read(filterValue.slice(1, -1).split(' TO '), 2), from = _a[0], to = _a[1];
        return { from: from, to: to };
    }
    if (isMaxOrMinFilter) {
        var _b = __read(filterValue.split('='), 2), operator = _b[0], value = _b[1];
        return operator === '<' ? { from: null, to: value } : { from: value, to: null };
    }
    return { from: filterValue, to: null };
};
function NumberFilterInput(_a) {
    var filterId = _a.filterId, placeholder = _a.placeholder, filterValue = _a.filterValue, handleInputChange = _a.handleInputChange, inputRef = _a.inputRef, setIssueForFilter = _a.setIssueForFilter, isOpen = _a.isOpen;
    var _b = __read((0, react_1.useState)('1'), 2), inputMode = _b[0], setInputMode = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isRangeInvalid = _c[0], setIsRangeInvalid = _c[1];
    var _d = determineRange(filterValue), from = _d.from, to = _d.to;
    var t = (0, react_i18next_1.useTranslation)().t;
    var inputModeItems = [
        { id: '1', text: t('SEARCH.SEARCH_QUERY_BUILDER.EQUAL') },
        { id: '2', text: t('SEARCH.SEARCH_QUERY_BUILDER.FROM_TO') },
    ];
    (0, react_1.useEffect)(function () {
        var isRange = filterValue && (filterValue.includes(' TO ') || filterValue.includes('>=') || filterValue.includes('<='));
        if (isRange)
            return setInputMode('2');
    }, [isOpen]);
    (0, react_1.useEffect)(function () {
        setIssueForFilter(isRangeInvalid ? t('SEARCH.SEARCH_QUERY_BUILDER.INVALID_RANGE') : '');
    }, [isRangeInvalid]);
    (0, react_1.useEffect)(function () {
        setIsRangeInvalid(!!(from && to && parseInt(from) > parseInt(to)));
    }, [from, to]);
    var handleRangeChange = function (from, to) {
        if (from && to)
            return handleInputChange(filterId, "[".concat(from, " TO ").concat(to, "]"));
        if (from)
            return handleInputChange(filterId, ">=".concat(from));
        if (to)
            return handleInputChange(filterId, "<=".concat(to));
        return handleInputChange(filterId, '');
    };
    var handleInputModeChange = function (id) {
        setInputMode(id);
        if (id === '1') {
            handleInputChange(filterId, from || '');
        }
        else {
            handleRangeChange(from, null);
        }
    };
    return (react_1.default.createElement("div", { className: "filter-date-wrapper" },
        react_1.default.createElement(SelectDropdown_1.default, { items: inputModeItems, selectedItemId: inputMode, onItemSelected: function (id) { return handleInputModeChange(id); } }),
        inputMode === '2' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Input_1.default, { placeholder: placeholder, value: from || '', onTextChange: function (text) {
                    var sanitizedText = sanitizeInputText(text);
                    handleRangeChange(sanitizedText, to);
                }, inputRef: inputRef, type: "text", id: "filter-before-".concat(filterId), className: "form-control ".concat(isRangeInvalid ? 'focus ng-invalid' : '') }),
            react_1.default.createElement(Input_1.default, { placeholder: placeholder, value: to || '', onTextChange: function (text) {
                    var sanitizedText = sanitizeInputText(text);
                    handleRangeChange(from, sanitizedText);
                }, inputRef: inputRef, type: "text", id: "filter-to-".concat(filterId), className: "form-control ".concat(isRangeInvalid ? 'focus ng-invalid' : '') }))),
        inputMode === '1' && (react_1.default.createElement(Input_1.default, { placeholder: placeholder, value: from || '', onTextChange: function (text) {
                var sanitizedText = sanitizeInputText(text);
                if (from !== sanitizedText) {
                    handleInputChange(filterId, sanitizedText);
                }
            }, inputRef: inputRef, type: "text", id: "filter-equal-".concat(filterId), className: "form-control" }))));
}
exports.default = NumberFilterInput;
